import { getLocale } from './i18n';

const LocalePlugin = {
    install: (app, options) => {
        app.config.globalProperties.$locale = getLocale();
    },
};

export default LocalePlugin;
